module.exports = __webpack_public_path__ + "img/space_dust_cherry_front.a2a55ea1.jpg";